import { DivisionCliente } from '@interfaces/firestore-documents.interfaces';
import useDivisionInformationStyles from './DivisionInformation.styles';
import { Typography } from '@mui/material';
import { ListItem } from '@features/common';

interface Props {
	data: DivisionCliente;
}

const DivisionInformation: React.FC<Props> = ({ data }) => {
	const classes = useDivisionInformationStyles();

	return (
		<div className={classes.root} id="division-information">
			<div className={classes.headerContainer}>
				<Typography align="center" fontFamily="Montserrat" fontSize={14}>
					Division:{' '}
					<Typography
						component="span"
						fontSize={14}
						fontWeight={600}
						style={{ display: 'inline-block' }}
					>
						{data.codigo_div}
					</Typography>
				</Typography>
				<Typography
					align="center"
					fontFamily="Montserrat"
					fontSize={16}
					fontWeight={800}
					style={{ letterSpacing: 0, marginTop: 8 }}
				>
					{data.nombre_div}
				</Typography>
			</div>
			<ListItem
				margin
				id="division-information-business-advisor"
				style={{ maxWidth: 187 }}
				title="Asesor comercial"
				value={data.nombre_asesor_comercial || 'Sin registrar'}
			/>
			<ListItem
				margin
				id="division-information-account-terminal"
				style={{ maxWidth: 187 }}
				title="Terminal de cuenta"
				value={data.terminal_de_cuenta || 'Sin registrar'}
			/>
			<ListItem
				margin
				id="division-information-payment-terminal"
				style={{ maxWidth: 187 }}
				title="Terminal de cobro"
				value={data.terminal_de_cobro || 'Sin registrar'}
			/>
			<ListItem
				margin
				id="division-information-account-type"
				style={{ maxWidth: 187 }}
				title="Tipo de cuenta"
				value={data.tipo_de_cuenta || 'Sin registrar'}
			/>
		</div>
	);
};

export default DivisionInformation;
